export default __webpack_public_path__ + "static/media/aluminiumExtrusion.7daf3f28.webp";